export default "__VITE_ASSET__7e0073bd__"